<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="returnModal" width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>برگشت از خرید</h4>
        </v-card-title>
        <v-card-text>
          <v-container class="mt-4">
            <h5 class="text-right">آیا از برگشت خرید ثبت شده اطمینان دارید؟</h5>
            <div class="text-left pt-4">
              <v-btn class="red white--text mx-1" @click="returnModal = false"
                >خیر</v-btn
              >
              <v-btn
                color="primary"
                class="mx-1"
                :loading="busy"
                @click="submit"
                >بله</v-btn
              >
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <loading v-if="vLoading" />

    <v-col lg="12" class="ml-auto"></v-col>
    <b-card
      v-if="$router.currentRoute.path == '/shop/purchaseInvoices'"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <template v-slot:header>
        <v-row>
          <v-col>
            <h4 class="m-0 pt-1">مدیریت فاکتورهای خرید</h4>
          </v-col>
          <v-col>
            <!-- <v-btn style="float: left" @click="shopNewInvoiceDialog()">
              ثبت جدید +
            </v-btn> -->
            <router-link
              to="/shop/newPurchaseInvoice"
              style="float: left"
              class="btn btn-dark"
            >
              + ثبت فاکتور جدید +</router-link
            >
          </v-col>
        </v-row>
      </template>
      <br />
      <b-card class="shadow p-3 mb-5 bg-white rounded">
        <template v-slot:header>
          <v-row class="p-0">
            <v-col cols="4">
              <date-picker
                placeholder="تاریخ شروع"
                v-model="startDate"
                :editable="true"
              ></date-picker
            ></v-col>
            <v-col cols="4">
              <date-picker
                placeholder="تاریخ پایان"
                v-model="endDate"
                :editable="true"
              ></date-picker
            ></v-col>

            <v-col cols="4">
              <b-btn class="btn btn-dark" @click="searchInvoices()"
                >جستجو</b-btn
              >
            </v-col>
          </v-row>
        </template>
        <v-row class="p-0">
          <v-col cols="12" class="pb-0 mt-3">
            <v-text-field
              v-model="userInput"
              placeholder="جستجو"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <b-table
          responsive
          show-empty
          :items="invoices"
          :fields="fields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
          :current-page="currentPage"
          :per-page="perPage"
          :busy="isBusy"
          :filter="userInput"
          id="invoices-table"
          @filtered="onFiltered"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(shopCustomerName)="data">
            <div style="text-align: center; vertical-align: middle">
              <router-link :to="'/shop/customer/' + data.item.shopCustomerId">{{
                data.value
              }}</router-link>
            </div>
          </template>
          <template v-slot:cell(invoiceCode)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }} ({{ data.item.type }})
            </div>
          </template>

          <template v-slot:cell(totalCost)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value.toLocaleString() }} ریال
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-btn
                :disabled="gettingReceipt"
                class="mr-1"
                variant="primary"
                @click="print(data.item)"
                >چاپ رسید</b-btn
              >
              <b-btn
                :disabled="gettingReceipt"
                class="mr-1 red white--text"
                v-if="data.item.status == 'ثبت شده'"
                @click="openModal(data.item)"
                >برگشت از خرید</b-btn
              >
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (currentPage - 1) }}
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>

        <b-pagination
          v-model="currentPage"
          :total-rows="TotalRows"
          :per-page="perPage"
          aria-controls="invoices-table"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-card>
      <br />
    </b-card>

    <v-dialog v-model="newInvoiceDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ثبت فاکتور جدید</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-select
              label="نوع فاکتور"
              :items="invoiceTypes"
              v-model="newInvoice.type"
              :loading="progress"
              outlined
              dense
            />
            <v-autocomplete
              @change="getBalance(newInvoice.shopCustomerId)"
              auto-select-first
              no-data-text="نتیجه‌ای یافت نشد!"
              v-model="newInvoice.shopCustomerId"
              :items="customers"
              item-text="name"
              item-value="id"
              class="p-0"
              label="نام مشتری"
              dense
              outlined
            ></v-autocomplete>
            <p v-if="newInvoice.shopCustomerId">
              مانده حساب مشتری:
              <span v-if="newInvoice.customerBalance">{{
                newInvoice.customerBalance
              }}</span>
              <b-spinner v-else></b-spinner>
            </p>

            {{ totalCost ? Number(totalCost).toLocaleString() + "ریال" : "" }}
            <v-text-field
              outlined
              dense
              label="توضیحات"
              :loading="progress"
              v-model="newInvoice.description"
              @keyup.enter="addInvoice()"
            ></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="newInvoiceDialog = false"
          >
            لغو
          </v-btn>
          <v-btn color="primary" @click="addInvoice()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- receipt -->
    <v-card>
      <div id="Receipt" v-show="false">
        <table class="mainTable m-3 p-4 h-100 w-100">
          <thead>
            <tr>
              <td>
                <div style="text-align: center; width: 100%">
                  <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content" style="padding: 5px 15px">
                  <div
                    style="
                      border: 1px solid black;
                      border-radius: 10px;
                      padding: 0 10px;
                      min-height: 90px;
                      margin-bottom: 10px;
                    "
                  >
                    <div style="text-align: center">
                      <span style="font-size: 20px">فاکتور خرید</span>
                    </div>
                    <!-- <div>
                      <span style="float:right">
                        نام مشتری:
                        <span style="font-size = 16px">{{
                          printInvoice.shopCustomerName
                        }}</span>
                      </span>
                      <span style="float:left">
                        شماره فاکتور:
                        <span style="font-size = 16px">{{
                          printInvoice.code
                        }}</span>
                        (چاپ مجدد)
                      </span>
                    </div>
                    <br />
                    <div>
                      <span style="float:right">
                        کد مشتری:
                        <span style="font-size = 16px">{{
                          printInvoice.shopCustomerCode
                        }}</span>
                      </span>
                      <span style="float:left">
                        تاریخ صدور:
                        <span style="font-size = 16px">{{
                          printInvoice.date
                        }}</span>
                      </span>
                    </div>
                    <br />
                    <div>
                      <span style="float:right">
                        نوع مشتری:
                        <span style="font-size = 16px">{{
                          printInvoice.shopCustomerType
                        }}</span>
                      </span>
                      <span style="float:left">
                        ساعت صدور:
                        <span style="font-size = 16px">{{
                          printInvoice.time
                        }}</span>
                      </span>
                    </div>-->
                    <div>
                      <span style="float: right">
                        تاریخ صدور:
                        <span style="font-size = 16px">{{
                          printInvoice.date
                        }}</span>
                      </span>
                    </div>
                    <br />
                    <div>
                      <span style="float: right">
                        ساعت صدور:
                        <span style="font-size = 16px">{{
                          printInvoice.time
                        }}</span>
                      </span>
                    </div>
                  </div>
                  <b-table
                    bordered
                    :fields="selectedFields"
                    :items="printInvoice.details"
                    small="small"
                    responsive
                  >
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell(name)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(amount)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(price)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }} ریال
                      </div>
                    </template>
                    <template v-slot:cell(totalPrice)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{
                          (
                            Number(data.item.amount) * data.item.price
                          ).toLocaleString()
                        }}
                        ریال
                      </div>
                    </template>
                  </b-table>
                  <br />
                  <div>
                    <span>
                      {{
                        "مبلغ کل: " +
                        Number(printInvoice.totalCost).toLocaleString()
                      }}
                      ریال
                    </span>
                  </div>
                  <br />
                  <div
                    style="
                      border: 1px solid grey;
                      border-radius: 10px;
                      min-height: 80px;
                      padding: 10px;
                    "
                  >
                    <span>توضیحات: {{ printInvoice.description }}</span>
                  </div>
                  <br />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-card>
    <!-- receipt -->
    <br />
    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },

  data: function () {
    return {
      guide: false,

      moment: moment,
      gettingReceipt: false,
      startDate: moment(new Date()).subtract(7, "days").format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      fields: [
        { key: "index", label: "ردیف" },
        // { key: "shopCustomerName", label: "نام مشتری" },
        // { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "totalCost", label: "مبلغ" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      invoiceTypes: [
        { value: "definite", text: "قطعی - پرداخت در لحظه" },
        { value: "respite", text: "امانی - پرداخت اعتباری" },
      ],
      selectedFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل" },
        // { key: "sum", label: "موجودی" },
        // { key: "operation", label: "عملیات" },
      ],
      customers: [],
      customerName: "",
      customerPriority: "",
      customerMobile: "",
      customerEmail: "",
      customerDialog: false,
      userInput: "",
      currentPage: 1,
      perPage: 10,
      TotalRows: 1,
      striped: true,
      selectedCustomer: {},
      isBusy: true,
      busy: false,
      filter: null,
      invoices: [],
      selected: "",
      newInvoiceDialog: false,
      newInvoice: {
        customerBalance: "",
      },
      progress: false,
      customer: {},
      printInvoice: {},
      returnModal: false,
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    openModal(item) {
      this.returnModal = true;
      this.selected = item;
    },
    submit() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/purchases/return",
        {
          shopInvoiceId: this.selected.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.returnModal = false;
            this.searchInvoices();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.busy = false;
        });
    },
    print(item) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/getInfo",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          this.printReceipt();
        })
        .catch((err) => {
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "Receipt", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("Receipt").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    delFilter() {
      // this.sortBy = "";
      this.userInput = "";
      // this.isBusy = true;
      // this.searchInvoices();
    },
    shopNewInvoiceDialog() {
      this.newInvoiceDialog = true;
    },
    getBalance(customerId) {
      this.newInvoice.customerBalance = "";
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/customerBalance",
        {
          shopCustomerId: customerId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.newInvoice.customerBalance = Number(
              res.data.balance.split(",").join("")
            );
            if (this.newInvoice.customerBalance > 0) {
              this.newInvoice.customerBalance =
                this.newInvoice.customerBalance.toLocaleString() +
                " ریال بدهکار";
            } else if (this.newInvoice.customerBalance < 0) {
              this.newInvoice.customerBalance =
                Math.abs(this.newInvoice.customerBalance).toLocaleString() +
                " ریال بستانکار";
            } else {
              this.newInvoice.customerBalance = "تسویه";
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    addInvoice() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/new",
        {
          shopCustomerId: this.newInvoice.shopCustomerId,
          type: this.newInvoice.type,
          totalCost: this.newInvoice.totalCost,
          itemIds: this.newInvoice.itemIds,
          details: this.newInvoice.details,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.newInvoice = {};
            this.newInvoiceDialog = false;
            this.searchInvoices();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.isBusy = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.isBusy = false;
        });
    },
    editCustomer() {
      this.progress = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/edit",
        {
          shopCustomerId: this.selected,
          name: this.customer.name,
          mobile: this.customer.mobile,
          email: this.customer.email,
          economicCode: this.customer.economicCode,
          phone: this.customer.phone,
          address: this.customer.address,
          natCode: this.customer.natCode,
          type: this.customer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.customerDialog = false;
            this.isBusy = true;
            this.customerName = "";
            this.customerPriority = "";
            this.customerEmail = "";
            this.customerMobile = "";
            this.searchInvoices();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.customerDialog = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    getCustomerInfo() {
      this.progress = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/getInfo",
        {
          shopCustomerId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.customer.name = res.data.name;
            this.customer.mobile = res.data.mobile;
            this.customer.email = res.data.email;
            this.customer.economicCode = res.data.economicCode;
            this.customer.phone = res.data.phone;
            this.customer.address = res.data.address;
            this.customer.natCode = res.data.natCode;
            this.customer.type = res.data.type;
            this.customer.balance = res.data.balance;
            this.progress = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    showCustomerDialog(customer) {
      this.customerDialog = true;
      this.customerName = "";
      this.selected = customer;
      this.getCustomerInfo();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    searchInvoices() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/purchases/invoices",
        {
          startDate: this.startDate + "00:00",
          endDate: this.endDate + "23:59",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.invoices = res.data;
            this.TotalRows = this.invoices.length;
            this.vLoading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.vLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
          this.vLoading = false;
        });
    },
    getCustomers() {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.customers = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    getProducts() {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.customers = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },
  computed: {
    totalCost() {
      return 1000;
    },
  },

  mounted() {
    this.searchInvoices();
    this.getCustomers();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
thead {
  background-color: white;
  color: black;
}

@media print {
  td {
    font-family: "iransans" !important;
  }
  @page {
    size: A5 landscape;
    font-size: 30%;
    text-color: black;
  }

  table.mainTable {
    border: 0px !important;
  }
}
</style>
